import { render } from "./Attendees.vue?vue&type=template&id=517cade0&scoped=true&bindings={}"
import script from "./Attendees.vue?vue&type=script&lang=js"
export * from "./Attendees.vue?vue&type=script&lang=js"

import "./Attendees.vue?vue&type=style&index=0&id=517cade0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-517cade0"

export default script